// extracted by mini-css-extract-plugin
module.exports = {"container":"LoginInfo_container__1oNgG","header":"LoginInfo_header__2rSxx","text":"LoginInfo_text__3Ni-D","link":"LoginInfo_link__ftR-K"};